var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"top-header"}},[_c('dv-decoration-8',{staticClass:"header-left-decoration",staticStyle:{"width":"35%"}}),_c('dv-decoration-8',{staticClass:"header-right-decoration",staticStyle:{"width":"35%"},attrs:{"reverse":true}}),_c('div',{staticClass:"center-title"},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }